<template>
    <Head title="Email Verification" />

    <div class="relative lg:fixed h-full shrink-0 justify-center md:px-12 lg:px-0 bg-white">
        <div class="relative z-10 flex flex-1 flex-col h-full bg-white px-4 py-10 shadow-2xl md:flex-none md:px-28 overflow-y-scroll overflow-x-hidden scrollbar-hide">
            <jet-authentication-card class="">
                <div class="flex justify-center items-center">
                    <jet-authentication-card-logo-colored />
                </div>

                <div class="mb-4 text-sm text-gray-600 mt-8">
                    Thank you for signing up! Before getting started, please verify your email address by clicking on the link we just emailed to you. If you didn’t receive the email, we will gladly send you another.
                </div>

                <div class="mb-4 text-sm text-black">
                    The email you entered is: <span class="font-bold bg-yellow-300">{{ $page.props.auth.user.email }}</span>. If you entered your email incorrectly you can change it by going to your <inertia-link :href="route('profile.show')" class="underline font-bold">profile page</inertia-link>. After you update your email address come back to this page and click the Resend Verification Email button.
                </div>

                <div class="text-sm text-gray-600 mt-4">
                    If the verification email is not in your inbox, please check your SPAM folder. For further assistance, contact our support team.
                </div>

                <div class="mb-2 mt-4 font-medium text-sm text-red-600" v-if="invalidVerificationLink">
                    The email verification link you used is invalid or has expired. Please request a new verification email below.
                </div>

                <div class="mb-4 mt-2 font-medium text-sm text-green-600" v-if="verificationLinkSent">
                    A new verification link has been sent to the email address you provided during registration.
                </div>

                <form @submit.prevent="submit">
                    <div class="mt-4 flex items-center justify-between">
                        <jet-button custom_class="group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-black active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600 w-full" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Resend Verification Email
                        </jet-button>
                    </div>
                    <Link :href="route('logout')" method="post" as="button" class="underline text-sm text-gray-600 hover:text-gray-900 mt-3">Log Out</Link>
                </form>
            </jet-authentication-card>
        </div>
    </div>
    <div class="lg:pl-72 h-screen rentrisk-sidebar-gradient"></div>
</template>

<script setup>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue'
import JetButton from '@/Jetstream/Button.vue'
import {Head, Link, useForm} from '@inertiajs/vue3'
import { router } from '@inertiajs/vue3'
import {computed} from "vue";

const props = defineProps({
    status: String
})

const form = useForm({
    remember: false
})

const verificationLinkSent = computed(() => {
    return props.status === 'verification-link-sent';
})

const invalidVerificationLink = computed(() => {
    return props.status === 'verification-link-invalid';
})
function submit() {
    router.post(route('verification.send'))
}

// computed: {
// verificationLinkSent() {
//     return this.status === 'verification-link-sent';
// }
// }
// }
</script>
